import api from '@/api/index'

export default {
  logout: async () => {
    const response = await api.auth.logout()
    return response
  },
}
